import styled, { css } from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import CheckIcon from '../../../images/common/check_fill_navy.svg';

export const Dialog = styled.div`
  width: 830px;
  background-color: ${ColorSF2.white};
  @media (max-height: 700px) {
    height: 500px;
  }
  @media (max-height: 500px) {
    height: 410px;
  }
`;
export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0;
`;
export const SearchBoxWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
export const CheckboxWrapper = styled.div`
  margin: 15px;
  display: flex;
  align-items: center;
`;
export const Checkbox = styled.div`
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const DefaultCheckbox = styled.input`
  display: none;
`;
export const CheckboxLabel = styled.label`
  margin-right: 8px;
  width: 20px;
  height: 20px;
`;
export const MediaContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-y: auto;
  @media (max-height: 700px) {
    height: 230px;
  }
  @media (max-height: 500px) {
    height: 170px;
  }
`;
export const ImageWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: start;
  height: 400px;
  width: 800px;
  overflow-y: auto;
`;
export const ImageContainer = styled.div`
  width: 120px;
  height: 120px;
  background-color: #000;
  text-align: center;
  margin: 5px;
  cursor: pointer;
  display: inline-block;
  position: relative;

  // 選択された画像には選択された順番を表示する
  ${({ isAddImageSelected, dataIndex }) =>
    isAddImageSelected &&
    css`
      &::after {
        content: '${dataIndex}';
        position: absolute;
        top: 0;
        right: 0;
        background-color: ${ColorSF2.navyBlue};
        color: white;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        border: 2px solid white;
        transform: translate(-25%, 25%);
        box-sizing: content-box;
      }
    `}

  ${({ isUpdateImageSelected }) =>
    isUpdateImageSelected &&
    css`
      border: 3px solid ${ColorSF2.navyBlue};
      &::after {
        content: '';
        position: absolute;
        width: 24px;
        height: 24px;
        background-image: url(${CheckIcon});
        background-size: 24px;
        background-repeat: no-repeat;
        background-position: center;
        background-color: white;
        border-radius: 50%;
        top: 0;
        right: 0;
        transform: translate(-25%, 25%);
      }
    `}
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;
